import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { useState } from "react";
import { Link } from "react-router-dom";

const tabs = [
  { id: "mentions", label: "Impressum", icon: "ri-building-line" },
  { id: "cgu", label: "AGB", icon: "ri-file-text-line" },
  { id: "confidentialite", label: "Datenschutz", icon: "ri-shield-user-line" },
  { id: "cookies", label: "Cookies", icon: "ri-cookie-line" },
];

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mb-10">
      <h2 className="font-playfair text-2xl font-bold text-slate-900 mb-4 pb-3 border-b border-slate-100">{title}</h2>
      <div className="space-y-3 text-slate-600 text-sm leading-relaxed">{children}</div>
    </div>
  );
}

function P({ children }: { children: React.ReactNode }) {
  return <p>{children}</p>;
}

function MentionsContent() {
  return (
    <>
      <Section title="Herausgeber der Website">
        <P><strong className="text-slate-800">Unternehmensbezeichnung:</strong> Dreamify gGmbH</P>
        <P><strong className="text-slate-800">Rechtsform:</strong> Gemeinnützige Gesellschaft mit beschränkter Haftung (gGmbH)</P>
        <P><strong className="text-slate-800">Sitz der Gesellschaft:</strong> Jungfernstieg 47, 20354 Hamburg, Deutschland</P>
        <P><strong className="text-slate-800">Umsatzsteuer-Identifikationsnummer:</strong> DE 123 456 789</P>
        <P><strong className="text-slate-800">Registernummer:</strong> HRB 12345 – Amtsgericht Hamburg</P>
        <P><strong className="text-slate-800">Verantwortlich für den Inhalt:</strong> Dr. Maximilian Hartmann</P>
        <P><strong className="text-slate-800">E-Mail:</strong> info@germantraumhauslotterie.de</P>
        <P><strong className="text-slate-800">Telefon:</strong> +49 (0) 40 123 456 78</P>
      </Section>

      <Section title="Aufsichtsbehörde">
        <P>Die German Traumhaus Lotterie wird unter offizieller Lizenz der <strong className="text-slate-800">Gemeinsamen Glücksspielbehörde der Länder (GGL)</strong> betrieben, gemäß dem Bescheid vom 28. Juni 2024.</P>
        <P><strong className="text-slate-800">Lizenznummer:</strong> GGL-2024-LOT-00847</P>
        <P><strong className="text-slate-800">Kontakt GGL:</strong> Hegelstraße 2, 55122 Mainz — <a href="https://www.gluecksspiel-behoerde.de" target="_blank" rel="noopener noreferrer" className="text-yellow-600 underline cursor-pointer">www.gluecksspiel-behoerde.de</a></P>
      </Section>

      <Section title="Hosting">
        <P><strong className="text-slate-800">Hoster:</strong> Hetzner Online GmbH</P>
        <P><strong className="text-slate-800">Adresse:</strong> Industriestraße 25, 91710 Gunzenhausen, Deutschland</P>
        <P><strong className="text-slate-800">Website:</strong> <a href="https://www.hetzner.com" target="_blank" rel="noopener noreferrer" className="text-yellow-600 underline cursor-pointer">www.hetzner.com</a></P>
      </Section>

      <Section title="Geistiges Eigentum">
        <P>Sämtliche Inhalte dieser Website (Texte, Bilder, Grafiken, Logo, Icons, Töne, Software…) sind das exklusive Eigentum der Dreamify gGmbH, mit Ausnahme von Elementen, die von Partnern oder Dritten bereitgestellt wurden.</P>
        <P>Jede Vervielfältigung, Darstellung, Änderung, Veröffentlichung oder Anpassung aller oder eines Teils der Elemente der Website, unabhängig vom verwendeten Mittel oder Verfahren, ist untersagt, es sei denn, es liegt eine vorherige schriftliche Genehmigung der Dreamify gGmbH vor.</P>
      </Section>

      <Section title="Haftung">
        <P>Die Dreamify gGmbH bemüht sich nach Kräften, verfügbare und geprüfte Informationen bereitzustellen. Es können jedoch Fehler oder Auslassungen auftreten. Der Nutzer erklärt sich damit einverstanden, diese Informationen auf eigene Verantwortung zu nutzen.</P>
        <P>Hypertext-Links können auf andere Websites verweisen. Die Dreamify gGmbH lehnt jede Verantwortung für den Inhalt dieser Websites Dritter ab.</P>
      </Section>
    </>
  );
}

function CguContent() {
  return (
    <>
      <Section title="1. Gegenstand">
        <P>Diese Allgemeinen Nutzungsbedingungen (AGB) regeln den Zugriff auf und die Nutzung der Website <strong className="text-slate-800">germantraumhauslotterie.de</strong> sowie die Teilnahme an der von der Dreamify gGmbH organisierten Immobilienlotterie German Traumhaus Lotterie.</P>
        <P>Durch den Zugriff auf die Website und/oder den Kauf von Losen akzeptiert der Nutzer diese AGB vorbehaltlos.</P>
      </Section>

      <Section title="2. Teilnahmebedingungen">
        <P><strong className="text-slate-800">2.1 Alter:</strong> Die Teilnahme ist strengstens auf natürliche Personen beschränkt, die mindestens <strong className="text-slate-800">18 Jahre</strong> alt sind. Die Dreamify gGmbH behält sich das Recht vor, das Alter jedes Teilnehmers zu überprüfen.</P>
        <P><strong className="text-slate-800">2.2 Geografische Zone:</strong> Die Teilnahme steht Bewohnern der Europäischen Union offen. Jede Teilnahme aus einem Land, in dem Lotterien verboten sind, ist untersagt.</P>
        <P><strong className="text-slate-800">2.3 Einschränkung:</strong> Mitarbeiter und Dienstleister der Dreamify gGmbH sowie deren nahe Verwandte sind von der Teilnahme ausgeschlossen.</P>
      </Section>

      <Section title="3. Kauf von Losen">
        <P><strong className="text-slate-800">3.1 Preis:</strong> Der Preis der Lose wird in Euro inkl. MwSt. auf der Paketseite angezeigt. Die Preise sind verbindlich und nicht verhandelbar.</P>
        <P><strong className="text-slate-800">3.2 Zahlung:</strong> Die Zahlung erfolgt online über die angebotenen sicheren Lösungen (Karte, PayPal, Klarna, SEPA…). Eine Teilnahme wird erst nach Erhalt der vollständigen Zahlung berücksichtigt.</P>
        <P><strong className="text-slate-800">3.3 Keine Rückerstattung:</strong> Gemäß den geltenden Regeln für Glücksspiele und digitale Inhalte sind gekaufte Lose nicht erstattungsfähig, es sei denn, die Ziehung wird durch die Dreamify gGmbH abgesagt.</P>
        <P><strong className="text-slate-800">3.4 Bestätigung:</strong> Nach dem Kauf erhält der Teilnehmer innerhalb von 5 Minuten eine Bestätigungs-E-Mail mit seinen Teilnahmenummern.</P>
      </Section>

      <Section title="4. Ablauf der Ziehung">
        <P><strong className="text-slate-800">4.1 Datum:</strong> Die Ziehung ist für den 15. Juni 2026 geplant. Die Dreamify gGmbH behält sich das Recht vor, die Ziehung im Falle höherer Gewalt oder technischer Unmöglichkeit zu verschieben, ohne dass dies ihre Haftung begründet.</P>
        <P><strong className="text-slate-800">4.2 Aufsicht:</strong> Die Ziehung wird von einem unabhängigen Notar überwacht, der von der Dreamify gGmbH beauftragt wurde, um Fairness und absolute Transparenz zu gewährleisten.</P>
        <P><strong className="text-slate-800">4.3 Methode:</strong> Die Ziehung erfolgt durch eine zertifizierte Zufallsauswahl einer Gewinnnummer aus allen verkauften Teilnahmenummern.</P>
      </Section>

      <Section title="5. Gewinnzuteilung">
        <P><strong className="text-slate-800">5.1 Hauptgewinn:</strong> Die Villa auf der Insel Föhr mit einem geschätzten Wert von 1.500.000 € wird dem Gewinner innerhalb von 60 Tagen nach der Ziehung per notarieller Urkunde in vollem Eigentum übertragen.</P>
        <P><strong className="text-slate-800">5.2 Nebenfiguren:</strong> Geldgewinne werden innerhalb von 10 Werktagen nach Validierung der Identität des Gewinners per Banküberweisung ausgezahlt.</P>
        <P><strong className="text-slate-800">5.3 Nichtbeanspruchung:</strong> Wenn sich ein Gewinner nicht innerhalb von 90 Tagen nach der Benachrichtigung meldet, wird der Gewinn an die Partnerorganisation für wohltätige Zwecke gespendet.</P>
      </Section>

      <Section title="6. Verantwortung und verantwortungsbewusstes Spielen">
        <P>Die Dreamify gGmbH setzt sich für verantwortungsbewusstes Spielen ein. Wenn Sie glauben, ein Problem mit Spielsucht zu haben, kontaktieren Sie <a href="https://www.bundesweit-gegen-gluecksspielsucht.de" target="_blank" rel="noopener noreferrer" className="text-yellow-600 underline cursor-pointer">bundesweit-gegen-gluecksspielsucht.de</a>.</P>
        <P>Tools zur Selbstsperre und zur Begrenzung der Ausgaben sind in Ihrem Kontobereich verfügbar.</P>
      </Section>

      <Section title="7. Anwendbares Recht und Streitigkeiten">
        <P>Diese AGB unterliegen deutschem Recht. Jeder Streitfall unterliegt der ausschließlichen Zuständigkeit der Gerichte in Hamburg.</P>
        <P>Im Falle eines Rechtsstreits wird vorrangig eine gütliche Einigung über unseren Kundenservice gesucht (<a href="/contact" className="text-yellow-600 underline cursor-pointer">Kontaktseite</a>). Alternativ können Sie die europäische Plattform zur Online-Streitbeilegung nutzen: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-yellow-600 underline cursor-pointer">ec.europa.eu/consumers/odr</a>.</P>
      </Section>
    </>
  );
}

function ConfidentialiteContent() {
  return (
    <>
      <Section title="1. Verantwortlicher für die Verarbeitung">
        <P>Verantwortlich für die Verarbeitung personenbezogener Daten ist: <strong className="text-slate-800">Dreamify gGmbH</strong>, Jungfernstieg 47, 20354 Hamburg, Deutschland.</P>
        <P><strong className="text-slate-800">Datenschutzbeauftragter (DPO):</strong> info@germantraumhauslotterie.de</P>
      </Section>

      <Section title="2. Erhobene Daten">
        <P>Wir erheben nur die für die Erbringung unserer Dienstleistungen erforderlichen Daten:</P>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li><strong className="text-slate-700">Identifikationsdaten:</strong> Name, Vorname, E-Mail, Telefon, Geburtsdatum (Altersprüfung)</li>
          <li><strong className="text-slate-700">Zahlungsdaten:</strong> werden direkt von unseren Zahlungsdienstleistern (Stripe, PayPal) verarbeitet — wir speichern keine Kreditkartendaten</li>
          <li><strong className="text-slate-700">Teilnahmedaten:</strong> Losnummern, Kaufhistorie</li>
          <li><strong className="text-slate-700">Navigationsdaten:</strong> IP-Adresse, Cookies (siehe Abschnitt Cookies)</li>
        </ul>
      </Section>

      <Section title="3. Zwecke und Rechtsgrundlagen">
        <P><strong className="text-slate-800">Vertragserfüllung (Art. 6.1.b DSGVO):</strong> Verwaltung der Teilnahmen, Versand der Lose, Benachrichtigung der Gewinner, Abwicklung der Zahlungen.</P>
        <P><strong className="text-slate-800">Gesetzliche Verpflichtungen (Art. 6.1.c DSGVO):</strong> Buchhaltungs-, steuerliche Verpflichtungen, Betrugsbekämpfung, Altersprüfung.</P>
        <P><strong className="text-slate-800">Berechtigtes Interesse (Art. 6.1.f DSGVO):</strong> Verbesserung unserer Dienstleistungen, IT-Sicherheit, anonymisierte Statistiken.</P>
        <P><strong className="text-slate-800">Einwilligung (Art. 6.1.a DSGVO):</strong> Versand von Newslettern und Marketingkommunikation (jederzeit widerrufbar).</P>
      </Section>

      <Section title="4. Aufbewahrungsdauer">
        <P>Ihre Daten werden so lange aufbewahrt, wie es für die Vertragserfüllung erforderlich ist, danach:</P>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Kundendaten: <strong className="text-slate-700">5 Jahre</strong> nach Ende der Vertragsbeziehung</li>
          <li>Buchhaltungs- und Finanzdaten: <strong className="text-slate-700">10 Jahre</strong> (gesetzliche Verpflichtung)</li>
          <li>Cookies: <strong className="text-slate-700">maximal 13 Monate</strong></li>
        </ul>
      </Section>

      <Section title="5. Ihre Rechte">
        <P>Gemäß DSGVO haben Sie folgende Rechte, die Sie per E-Mail an info@germantraumhauslotterie.de ausüben können:</P>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li><strong className="text-slate-700">Auskunftsrecht</strong> (Art. 15) — eine Kopie Ihrer Daten erhalten</li>
          <li><strong className="text-slate-700">Recht auf Berichtigung</strong> (Art. 16) — unrichtige Daten korrigieren</li>
          <li><strong className="text-slate-700">Recht auf Löschung</strong> (Art. 17) — "Recht auf Vergessenwerden"</li>
          <li><strong className="text-slate-700">Recht auf Übertragbarkeit</strong> (Art. 20) — Ihre Daten in einem strukturierten Format erhalten</li>
          <li><strong className="text-slate-700">Widerspruchsrecht</strong> (Art. 21) — bestimmten Verarbeitungen widersprechen</li>
        </ul>
        <P>Sie können auch eine Beschwerde bei der zuständigen Aufsichtsbehörde einreichen (in Deutschland: <a href="https://www.bfdi.bund.de" target="_blank" rel="noopener noreferrer" className="text-yellow-600 underline cursor-pointer">bfdi.bund.de</a>).</P>
      </Section>

      <Section title="6. Datentransfers">
        <P>Ihre Daten werden in der Europäischen Union gehostet. Ohne angemessene Garantien (Standardvertragsklauseln der Europäischen Kommission) erfolgt kein Transfer in Drittländer.</P>
        <P>Unsere Auftragsverarbeiter unterliegen denselben DSGVO-Verpflichtungen durch Datenverarbeitungsverträge (DPA).</P>
      </Section>
    </>
  );
}

function CookiesContent() {
  return (
    <>
      <Section title="Was ist ein Cookie?">
        <P>Ein Cookie ist eine kleine Textdatei, die beim Besuch unserer Website auf Ihrem Endgerät (Computer, Smartphone, Tablet) abgelegt wird. Es ermöglicht die Speicherung von Informationen über Ihre Navigation.</P>
      </Section>

      <Section title="Auf dieser Website verwendete Cookies">
        <div className="overflow-x-auto">
          <table className="w-full text-xs border-collapse">
            <thead>
              <tr className="bg-slate-100">
                <th className="px-3 py-2 text-left font-semibold text-slate-700 border border-slate-200">Cookie</th>
                <th className="px-3 py-2 text-left font-semibold text-slate-700 border border-slate-200">Typ</th>
                <th className="px-3 py-2 text-left font-semibold text-slate-700 border border-slate-200">Dauer</th>
                <th className="px-3 py-2 text-left font-semibold text-slate-700 border border-slate-200">Zweck</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["session_id", "Essenziell", "Session", "Aufrechterhaltung der Sitzung"],
                ["csrf_token", "Essenziell", "Session", "Schutz vor CSRF-Angriffen"],
                ["cookie_consent", "Essenziell", "12 Monate", "Speicherung Ihrer Cookie-Präferenzen"],
                ["_ga", "Analytisch", "24 Monate", "Google Analytics — anonymisierte Reichweitenmessung"],
                ["_gid", "Analytisch", "24h", "Google Analytics — Unterscheidung von Sitzungen"],
                ["fbp", "Marketing", "3 Monate", "Facebook Pixel — Optimierung von Werbeanzeigen"],
              ].map(([name, type, duration, purpose]) => (
                <tr key={name} className="even:bg-slate-50">
                  <td className="px-3 py-2 border border-slate-200 font-mono text-slate-800">{name}</td>
                  <td className="px-3 py-2 border border-slate-200">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${type === "Essenziell" ? "bg-emerald-100 text-emerald-700" :
                        type === "Analytisch" ? "bg-sky-100 text-sky-700" :
                          "bg-orange-100 text-orange-700"
                       }`}>{type}</span>
                  </td>
                  <td className="px-3 py-2 border border-slate-200 text-slate-600">{duration}</td>
                  <td className="px-3 py-2 border border-slate-200 text-slate-600">{purpose}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section title="Ihre Präferenzen verwalten">
        <P>Sie können Ihre Cookie-Präferenzen jederzeit verwalten über:</P>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Ihre Browser-Einstellungen (Löschen, Blockieren)</li>
          <li>Unseren Consent-Manager am Ende jeder Seite</li>
          <li>Abmelde-Tools von Drittanbietern (z.B.: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-yellow-600 underline cursor-pointer">Google Analytics Opt-out</a>)</li>
        </ul>
        <P>Das Ablehnen essenzieller Cookies kann die Funktion der Website beeinträchtigen.</P>
      </Section>
    </>
  );
}

export default function MentionsLegales() {
  const [activeTab, setActiveTab] = useState("mentions");

  return (
    <main className="min-h-screen font-inter bg-slate-50">
      <Navbar />

      {/* Hero */}
      <div className="bg-slate-900 pt-28 pb-14 px-6">
        <div className="max-w-4xl mx-auto">
          <nav className="text-sm text-slate-500 mb-5">
            <Link to="/" className="hover:text-slate-300 cursor-pointer transition-colors">Startseite</Link>
            <span className="mx-2">/</span>
            <span className="text-slate-300">Rechtliche Informationen</span>
          </nav>
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-white mb-3">
            Rechtliche Informationen
          </h1>
          <p className="text-slate-400 text-base">
            Letzte Aktualisierung: 20. März 2026
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white border-b border-slate-200 sticky top-16 z-30">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex gap-0 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-5 py-4 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors cursor-pointer ${activeTab === tab.id
                    ? "border-yellow-400 text-slate-900"
                    : "border-transparent text-slate-500 hover:text-slate-800"
                  }`}
              >
                <i className={`${tab.icon} text-base`}></i>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-14">
        <div className="bg-white rounded-2xl border border-slate-100 p-8 md:p-12">
          {activeTab === "mentions" && <MentionsContent />}
          {activeTab === "cgu" && <CguContent />}
          {activeTab === "confidentialite" && <ConfidentialiteContent />}
          {activeTab === "cookies" && <CookiesContent />}
        </div>

        {/* Contact CTA */}
        <div className="mt-8 bg-slate-900 rounded-2xl p-7 flex flex-col md:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-white font-bold text-lg mb-1">Eine rechtliche Frage?</p>
            <p className="text-slate-400 text-sm">Unser Rechtsteam steht Ihnen zur Verfügung.</p>
          </div>
          <Link
            to="/contact"
            className="bg-yellow-400 hover:bg-yellow-300 text-slate-900 font-bold px-7 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-mail-line"></i>
            Kontaktieren Sie uns
          </Link>
        </div>
      </div>

      <Footer />
    </main>
  );
}
